import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { cameraSlice } from "./cameraSlice";
import { modelSlice } from "./modelSlice";
import { interactionSlice } from "./interactionSlice";

const rootReducer = combineReducers({
  [cameraSlice.name]: cameraSlice.reducer,
  [modelSlice.name]: modelSlice.reducer,
  [interactionSlice.name]: interactionSlice.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export const store = configureStore({
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(),
  reducer: rootReducer,
  devTools: true,
});


export type AppDispatch = typeof store.dispatch;